import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';
import { motion } from 'framer-motion';

const ContactUs = () => {
  return (
    <section className="relative mt-44 px-6 sm:px-10 overflow-hidden ">
      {/* Decorative Blur Background */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[600px] h-[600px]   pointer-events-none"></div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative max-w-6xl mx-auto bg-white/30 mb-20  p-8 sm:p-14"
      >
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-extrabold text-center text-yellow-700 mb-12">
          Get in Touch with Vamika Tours
        </h2>
        <p className="text-center text-gray-700 max-w-2xl mx-auto text-lg mb-12">
          Whether you're planning your next getaway or need help customizing your dream vacation,
          our team is here to help you every step of the way. Reach out to us anytime!
        </p>

        {/* Contact Grid */}
        <div className="grid md:grid-cols-2 gap-12 text-gray-700">
          {/* Contact Info */}
          <div>
            <h3 className="text-2xl font-semibold mb-5 text-yellow-600">Contact Information</h3>
            <ul className="space-y-4 text-[16px]">
              <li><strong>Phone:</strong> +91 9327953295</li>
              <li><strong>Alternate:</strong> +91 6377659957</li>
              <li><strong>Email:</strong> contact@vamikatours.com</li>
              <li><strong>Working Hours:</strong> Mon – Sat, 9 AM – 6 PM</li>
              <li><strong>Address:</strong>Ahmedabad, Gujarat</li>
            </ul>
          </div>

          {/* Embedded Map */}
          <div>
            <h3 className="text-2xl font-semibold mb-5 text-yellow-600">Find Your Destination</h3>
            <div className="rounded-xl overflow-hidden border shadow-lg h-[300px] sm:h-[350px] w-full">
              <iframe
                title="Vamika Tours Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15145.741986598352!2d73.81966755!3d15.4982897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfc0e0922fa23f%3A0xadc84f58f08e8c9b!2sPanaji%2C%20Goa!5e0!3m2!1sen!2sin!4v1714050000000!5m2!1sen!2sin"
                width="100%"
                height="100%"
                allowFullScreen=""
                loading="lazy"
                style={{ border: 0 }}
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="my-14 border-t border-gray-300"></div>

        {/* Social Icons */}
        <div className="text-center">
          <h3 className="text-xl font-semibold text-yellow-700 mb-4">Connect with Us</h3>
          <div className="flex justify-center gap-6">
            {/* <a href="#" className="text-yellow-600 hover:text-yellow-800 transition transform hover:scale-110">
              <FaFacebookF size={22} />
            </a> */}
            <a href="https://chat.whatsapp.com/HLY4HbwuVJTDJ0Q7cfuYW" className="text-yellow-600 hover:text-yellow-800 transition transform hover:scale-110">
              <FaWhatsapp size={22} />
            </a>
            <a href="https://www.instagram.com/vamikatours?igsh=ano0cHR0d2h0czRi&utm_source=qr" className="text-yellow-600 hover:text-yellow-800 transition transform hover:scale-110">
              <FaInstagram size={22} />
            </a>
            {/* <a href="#" className="text-yellow-600 hover:text-yellow-800 transition transform hover:scale-110">
              <FaLinkedinIn size={22} />
            </a> */}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default ContactUs;
